import React, { useEffect, useState } from 'react';
import Header from '../common/Header'
import Footer from '../common/Footer'
import '../style/products/common.css'
import logo from '../img/quanto_light.webp'

// checkmark circle icon
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { CirclePlus } from 'lucide-react';

export default function QuantoB2B() {
    const [activeTab, setActiveTab] = useState("features");
    const [animateItems, setAnimateItems] = useState(false);
    const [selectedPoint, setSelectedPoint] = useState(0);

    const features = [
        "Sales Benefits",
        "Purchase Benefits",
        "Inventory benefits",
        "Tools for Growth",
    ];

    const featuresDetails = [
        ["Fast billing based on design number, brand, shade number, etc., significantly saves time.", "Efficiently manage multiple price lists and discount rates tailored for different customer categories, ensuring customized pricing and promotions for each segment.", "Ensures GST Compliant billing by including HSN details for accurate tax reporting.Supports multi-company operations by managing billing across different entities and maintaining one roof reporting.", "Manage credit limits for suppliers, with automatic alerts sent via WhatsApp to top management at regular intervals.", "Create detailed reports on outstanding payments categorized by customer, region, state, and product category. This enables targeted tracking and management of overdue payments, improving financial oversight and collection efficiency."],
        ["Monitor the status of your bundles and products in real-time, whether at the lorry office, warehouse, or any other location—anytime, anywhere—ensuring complete visibility and control over your inventory.", "Monitor your purchase order status in real-time, providing instant visibility and updates throughout the entire process.", "Manage agent commissions, freight, and other charges in accordance with agreed terms, ensuring accurate and timely calculations for each transaction.", "An all-in-one purchase entry screen simplifies entering purchase details, making the process quick and efficient for seamless record-keeping.", "Track purchase entries based on agent, supplier, area, and location, providing comprehensive insights and organized records."],
        ["Get real-time insights into your stock position, organized by supplier, brand, design, and agent, for instant and detailed inventory tracking.", "An easy-to-use tool for conducting attribute-wise physical stock audits anytime, eliminating the need to wait until year-end for inventory checks.", "Stock reports are available in multiple formats, including quantity, pieces, meters, and bundles, for flexible and detailed inventory tracking.", "A smart reordering tool efficiently manages inventory, providing timely updates via SMS or WhatsApp to ensure optimal stock levels are maintained."],
        ["A B2B dashboard allows you to monitor entries and their status, along with detailed LR information, and offers options for e-way bill generation and e-invoice creation, all in one place.", "Advanced MIS reports and analytics provide graphical representations of sales, purchase, and inventory-related data, enabling better insights and informed decision-making.", "WhatsApp and SMS alerts notify customers and suppliers when an LR is booked or a payment is due, ensuring timely communication and updates.", "Third-party accounting integration with Tally ERP is available and can be easily implemented, allowing seamless financial management and data synchronization.", "Based on smart customer buying patterns, the system will recommend the likely quantity of products they are expected to purchase, tailored for each season."]
    ];

    const benefits = [
        "Increased Operational Efficiency",
        "Improved Customer Satisfaction",
        "Enhanced Decision-Making",
        "Cost Savings",
        "Scalability",
    ];

    const benefitsDetails = [
        "Streamline workflows and reduce manual tasks, freeing up time for more strategic activities.",
        "Deliver exceptional service with faster transactions, accurate inventory, and personalized experiences.",
        "Utilize advanced analytics to gain insights into performance metrics and market trends, facilitating strategic planning.",
        "Optimize inventory management and reduce overhead costs through efficient operations and accurate forecasting.",
        "Grow your retail business with a flexible ERP solution that adapts to your changing needs.",
    ];

    useEffect(() => {
        setAnimateItems(true);
        setSelectedPoint(0);
        const timer = setTimeout(() => setAnimateItems(false), 2200);
        return () => clearTimeout(timer);
    }, [activeTab]);

    const items = activeTab === "features" ? features : benefits;
    const details = activeTab === "features" ? featuresDetails : benefitsDetails;

    const handlePointClick = (index) => {
        setSelectedPoint(index);
    };

    // useEffect(() => {
    //     const button = document.querySelector('button');
    //     button.addEventListener('mouseover', () => {
    //         button.style.backgroundColor = '#b96d00';
    //         button.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
    //         button.style.transform = 'translateY(-2px)';
    //     });
    //     button.addEventListener('mouseout', () => {
    //         button.style.backgroundColor = 'transparent';
    //         button.style.boxShadow = '0 2px 5px rgba(0,0,0,0.2)';
    //         button.style.transform = 'translateY(0)';
    //     });
    // }, []);

    return (
        <>
            <Header />
            <section className="about-title-section">
                <h2><img alt="quantologo" src={logo} style={{ width: 280, marginLeft: 10, verticalAlign: "middle", marginBottom: 20 }} />B2B</h2>
            </section>
            <div style={styles.container} className='products-container'>
                <header style={styles.header}>
                    <h1 style={styles.titleInfo} className='products-section-title'>Quanto B2B : The Bridge between 2 Business Entities!</h1>
                </header>

                <section style={styles.section} className='products-inner-section'>
                    <h2 style={styles.sectionTitle} className='overview-heading'>Overview</h2>
                    <p style={styles.paragraph} className='overview-paragraph'>
                        Quanto B2B for the retail industry is a software solution that streamlines business-to-business processes like order management, inventory control, billing, payments and supplier coordination.
                        It enhances efficiency and collaboration between retailers and their suppliers, providing a unified platform to manage transactions, track stock, and optimize supply chain operations.
                    </p>
                </section>
                {/* <button style={{ ...styles.tabButton, margin: '5px auto' }}>Download Brochure</button> */}
                <style>
                    {`
                    @keyframes fadeIn {
                        0% { opacity: 0; transform: translateY(20px); scale(0.75) }
                        100% { opacity: 1; transform: translateY(0); scale(1.25) }
                    }
                    @keyframes grow2 {
                        0% { transform: scale(1); opacity: 1; }
                        50% { transform: scale(1.2); opacity: 0.6; color: black }
                        100% { transform: scale(1); opacity: 1; }
                    }
                    @keyframes pulseGlow {
                        0% {
                        transform: scale(1);
                        opacity: 1;
                        color: #ff8c00;
                        text-shadow: 0 0 10px rgba(255, 140, 0, 0.5);
                        }
                        50% {
                        transform: scale(1.1);
                        opacity: 0.8;
                        color: #ffc107;
                        text-shadow: 0 0 20px rgba(255, 193, 7, 0.7);
                        }
                        100% {
                        transform: scale(1);
                        opacity: 1;
                        color: #ff8c00;
                        text-shadow: 0 0 10px rgba(255, 140, 0, 0.5);
                        }
                    }
                    `}
                </style>

                <button
                    className='tab-btn-1'
                    style={{
                        ...styles.tabButton,
                        ...(activeTab === "features" ? styles.activeTabButton : {}),
                    }}
                    onClick={() => setActiveTab("features")}
                >
                    Benefits of Quanto B2B
                    <span style={styles.tabIcon}>
                        {activeTab === "features" ? "🟡" : "⚪"}
                    </span>
                </button>
                <div style={{ display: 'flex', width: "80%", alignSelf: 'center' }} className='points-container'>
                    <div style={styles.rightSection} className='products-right-section'>
                        <div style={styles.itemsContainer} className='products-right-inside-section'>
                            {items.map((item, index) => (
                                <div
                                    key={index}
                                    style={{
                                        ...styles.item,
                                        opacity: animateItems ? 0 : 1,
                                        animation: animateItems
                                            ? `fadeIn 0.5s ease-out ${index * 0.2}s forwards`
                                            : "none",
                                    }}
                                    className='check-points'
                                    onClick={() => handlePointClick(index)}
                                >
                                    {/* <span style={styles.itemIcon}>⦿</span> */}
                                    <CheckCircleOutlineIcon style={styles.itemIcon} />
                                    <span style={styles.itemText} className='products-item-text'>{item}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    {selectedPoint !== null && (
                        <div style={styles.detailsSection} className='products-details-section'>
                            <h2 style={styles.detailsTitle} className='products-details-title'>{items[selectedPoint]}</h2>
                            {/* <p style={styles.detailsText}>{details[selectedPoint]}</p> */}
                            {details[selectedPoint].map((detail, index) => (
                                <div key={index} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }} className='products-details-description'>
                                    {/* Icon */}
                                    <CirclePlus size={22} style={{
                                        color: '#ff8c00',
                                        marginRight: 10,
                                        marginTop: '6px', // Ensures alignment with the first line
                                        flexShrink: 0, // Prevents the icon from shrinking for multiline text
                                    }} />
                                    {/* Text */}
                                    <p style={{
                                        fontSize: "1.25em",
                                        lineHeight: "1.6",
                                        margin: 0,
                                    }}
                                        className='products-details-description'
                                    >
                                        {detail}
                                    </p>
                                </div>
                            ))}

                        </div>
                    )}
                </div>
            </div >
            <Footer />
        </>
    );
}

const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        background: "linear-gradient(135deg, #000000 0%, #434343 100%)",
        color: "#fff",
        padding: "20px",
        borderRadius: "20px",
        position: "relative",
        overflow: "hidden",
        minHeight: "80vh",
        width: "95vw",
        margin: "20px auto",
    },
    leftSection: {
        flex: "1",
        paddingRight: "20px",
        marginBottom: "30px",
        width: "100%"
    },
    rightSection: {
        // flex: "2",
        // position: "relative",
        width: "20vw",
        // alignSelf: "center",
        marginRight: 10
    },
    title: {
        fontSize: "3em",
        textAlign: "center",
        marginBottom: "20px",
    },
    tabContainer: {
        display: "flex",
        justifyContent: "center",
        gap: "20px",
    },
    tabButton: {
        backgroundColor: "transparent",
        border: "2px solid #ff8c00",
        color: "#fff",
        fontWeight: 700,
        padding: "15px 30px",
        // width: "400px",
        borderRadius: "35px",
        fontSize: "1.5em",
        cursor: "pointer",
        transition: "all 0.3s ease",
        display: "flex",

        alignItems: "center",
        justifyContent: "center",
        display: 'block',
        margin: '20px auto'
    },
    activeTabButton: {
        backgroundColor: "#f39d3c",
        color: "#000",
    },
    tabIcon: {
        marginLeft: "10px",
        animation: "pulseGlow 4.5s ease-in-out 0.5s infinite",
    },
    itemsContainer: {
        // display: "grid",
        // gridTemplateColumns: "repeat(1, 1fr)",
        // gridTemplateRows: "repeat(1, 1fr)",
        // gap: "20px",
        backgroundColor: "rgba(255, 140, 0, 0.8)",
        borderRadius: "20px",
        padding: "30px",
        height: "100%",
        // spread items evenly in space
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-evenly",
    },
    item: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        padding: "10px",
        borderRadius: "10px",
        transition: "background-color 0.3s ease",
    },
    itemIcon: {
        marginRight: "10px",
        fontSize: "30px",
        animation: "grow2 4.5s ease-in-out 0.5s infinite",
    },
    itemText: {
        fontSize: "1.5em",
        fontWeight: 600,
    },
    detailsSection: {
        // marginTop: "30px",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        borderRadius: "20px",
        padding: "20px",
        animation: "fadeIn 0.5s ease-out",
        width: "100vw",
        height: "90vh",
        // alignSelf: "center",
        boxSizing: "border-box",
    },
    detailsTitle: {
        fontSize: "2em",
        margin: 0,
        marginBottom: "15px",
        color: "#ff8c00",
        textAlign: 'center'
    },
    detailsText: {
        fontSize: "1.25em",
        lineHeight: "1.6",
        margin: 0,
    },

    header: {
        alignItems: 'center',
    },
    titleInfo: {
        fontSize: '2.3em',
        fontWeight: 700,
        color: '#fff',
        textAlign: "center",
        marginBottom: 30
    },
    button: {
        backgroundColor: '#f6a608',
        color: 'white',
        padding: '12px 24px',
        border: 'none',
        width: "300px",
        borderRadius: '30px',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 'bold',
        letterSpacing: '1px',
        transition: 'all 0.3s ease',
        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
        outline: 'none',
        margin: '20px auto',
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    section: {
        margin: '30px 0',
        width: "70vw",
        alignSelf: "center",
    },
    sectionTitle: {
        fontSize: '2em',
        fontWeight: 'bold',
        color: '#fff',
        marginBottom: '20px',
    },
    paragraph: {
        fontSize: '1.35em',
        lineHeight: '1.6',
        color: '#ccc',
    },
};

